import { render, staticRenderFns } from "./PatientForm.vue?vue&type=template&id=4bac7d35&scoped=true"
import script from "./PatientForm.vue?vue&type=script&lang=js"
export * from "./PatientForm.vue?vue&type=script&lang=js"
import style0 from "./PatientForm.vue?vue&type=style&index=0&id=4bac7d35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bac7d35",
  null
  
)

export default component.exports